import { routeCreator } from '@adrias-online/steiner';
import _ from 'lodash';

import helper from 'helpers/steinerHelper';
import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/interessiMarketing';

const routes = helper.generateRoutes('interessiMarketing', selectors);
const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'interessiMarketing' */ `modules/interessiMarketing/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('interessiMarketing', routes.patterns);
routeRegister.addLinks('interessiMarketing', links);

export default list;